module.exports = __webpack_public_path__ + "static/media/Bayan2.0a7cdf70.jpg";